import React, { CSSProperties } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Space } from 'antd';
import { DragOutlined } from '@ant-design/icons';
import Controls from './controls';
import { getMenuItems } from '../admin-knowledge-base.utils';
import Button from '/react4xp/mixins/ui/button/button';
import { Section } from '../admin-knowledge-base.type';

interface SortableSectionProps {
    section: Section;
    isActive: boolean;
    selectSection: (section: Section) => void;
    showUpdateForm: (section: Section) => void;
    showDeleteForm: (section: Section) => void;
    roles: string[];
    privileges: string[];
}

const SortableSection = ({
    section,
    isActive,
    selectSection,
    showDeleteForm,
    showUpdateForm,
    roles,
    privileges
}: SortableSectionProps) => {
    const { attributes, listeners, setNodeRef, transform, transition, setActivatorNodeRef } =
        useSortable({ id: section.id });

    const style: CSSProperties = {
        transform: CSS.Transform.toString(transform),
        cursor: 'move',
        transition,
    };

    return (
        <div
            ref={setNodeRef}
            style={style}
            {...attributes}
        >
            <Button
                onClick={(e: React.MouseEvent<HTMLElement>) => {
                    if ((e.target as HTMLElement).closest('button') === e.currentTarget)
                        selectSection(section);
                }}
                color={isActive ? 'gold' : ''}
                className="section-button"
                style={{ minWidth: '300px' }}
            >
                <Space align="center">
                    <DragOutlined
                        ref={setActivatorNodeRef}
                        style={{ cursor: 'move', fontSize: '1.25rem' }}
                        {...listeners}
                    />
                    {section.ru.title}
                    <Controls
                        items={getMenuItems<Section>(
                            section,
                            showUpdateForm,
                            showDeleteForm,
                            roles,
                            privileges,
                            'PRIV_CHAPTER_EDIT',
                            'PRIV_CHAPTER_DELETE',
                        )}
                        noLabel
                    />
                </Space>
            </Button>
        </div>
    );
};

export default SortableSection;
